import requestTDP from "./request-tdp";
import request from "./request";
import requestxr from "./request-xrlauncher";
import requestReport, { reportUrl } from "./request-report";
import hmacSHA256 from "crypto-js/hmac-sha256";
import encHex from "crypto-js/enc-hex";

export function getXrOTA(clientType, packageName) {
  // const clientType = "FFALCON-XR-TAURUS-1";

  let appSecret;
  // 统一升级平台 海外没有 测试环境
  // "https://hw-tdp-o.api.leiniao.com"; // 海外 2CE5E939F7AE7191
  //  国内测试环境请求接口：http://tdp-t.api.leiniao.com
  //  国内正式环境请求接口：http://tdp-o.api.leiniao.com
  switch (location.hostname) {
    case "ota.rayneo.com":
      appSecret = "2CE5E939F7AE7191";
      break;
    case "ota-hw-test.rayneo.cn":
      appSecret = "2CE0AFE84819A201";
      break;
    case "localhost":
      // appSecret = "2CE5E939F7AE7191";
      appSecret = "2CE0AFE84819A201";
      break;

    default:
      break;
  }

  const appId = "com.tcl.xrmanager.main";
  const dnum = "00000000";
  const mac = "00:00:00:00:00:00";
  const resourceList = [
    {
      packageName: packageName,
      // packageName: "taurus1p5",
      versionCode: 0,
    },
  ];
  const systemversion = "10";
  const signature = hmacSHA256(
    `appId=${appId}&clientType=${clientType}&dnum=${dnum}&mac=${mac}&resourceList=${JSON.stringify(
      resourceList
    )}&systemversion=${systemversion}&appSecret=${appSecret}`,
    appSecret
  )
    .toString(encHex)
    .toUpperCase();
  return requestTDP({
    url: `/tdp-api/f-operate/v1/getOperateUpgradeList`,
    method: "post",
    data: {
      appId,
      clientType,
      dnum,
      mac,
      resourceList,
      systemversion,
      signature,
    },
  });
}

export function getHeader() {
  return request({
    url: `/rest/channel/selectChannel`,
    method: "post",
    responseType: "json",
    contentType: "application/json",
    data: { count: 7, parentId: 0 },
  });
}

// 眼镜名：https://test.rayneo.cn/xr-richtex/?parentTag=GJSJ&tag=FFALCON-XR-TAURUS1.5-1
// 图：https://test.rayneo.cn/xr-richtex/?parentTag=GJSJ&tag=FFALCON-XR-TAURUS1.5-1-P
export function getDeviceName(tag) {
  return requestxr({
    url: `/v1/data/dict/getContent?parentTag=GJSJ&tag=${tag}`,
    method: "get",
  });
}
export function getDeviceImg(tag) {
  return requestxr({
    url: `/v1/data/dict/getContent?parentTag=GJSJ&tag=${tag}-P`,
    method: "get",
  });
}

export function reportData(data = {}, basicData = {}) {
  const dataObj = {
    basicInfo: toJSONKeyValue({
      userId: '584f9c5bab31fb1d59e138e1', // 数据接入平台注册的userId
      projectId: 'ce6c5aba126e42db947fa67049beab42', // 数据接入平台注册的projectId
      ...basicData,
    }),
    dataInfo: toJSONKeyValue({
      type: '3F0332A867', // 数据接入平台注册的type
      ...data,
    }),
  }
  if (navigator.sendBeacon) {
    navigator.sendBeacon(reportUrl, new Blob([stringify(dataObj)], {
      type: 'application/x-www-form-urlencoded'
    }))
  } else{
    requestReport({
      url: reportUrl,
      method: 'POST',
      data: stringify(dataObj),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      }
    })
  }
}

function toJSONKeyValue(obj) {
  const tem = {};
  Object.keys(obj).forEach((key) => {
    let value = obj[key];
    if (typeof value === "object") {
      value = JSON.stringify(value);
    }
    tem[key] = value;
  });
  return JSON.stringify(tem);
}

function stringify(data) {
  let str = [];
  Object.keys(data).map((key) => {
    if (typeof data[key] == "object") {
      str.push(`${key}=${encodeURIComponent(JSON.stringify(data[key]))}`);
    } else {
      str.push(`${key}=${encodeURIComponent(data[key])}`);
    }
  });
  if (str.length > 0) {
    return str.join("&");
  }
  return str.join("");
}

function getClientEnv() {
  const ua = navigator.userAgent;
  let osType = "PC";
  let osVersion = "Unknown";
  let phoneModel = "Unknown";

  if (/Windows/i.test(ua)) {
    osType = "Windows";
    const match = ua.match(/Windows NT ([0-9.]+)/);
    osVersion = match ? match[1] : "Windows";
  } else if (/Macintosh/i.test(ua)) {
    osType = "macOS";
    const match = ua.match(/Mac OS X ([0-9._]+)/);
    osVersion = match ? match[1].replace(/_/g, ".") : "macOS";
  } else if (/Linux/i.test(ua)) {
    osType = "Linux";
    osVersion = "Linux";
  }

  const browserType = "Chrome";
  const versionMatch = ua.match(/(chrome|firefox|safari|opera|opr|edge|edg|qqbrowser|micromessenger)\/?\s*([0-9.]+)/i);
  const browserVer = versionMatch ? versionMatch[2] : "";
  phoneModel = browserType + (browserVer ? " " + browserVer : "");

  return { osType, osVersion, phoneModel };
}

function getAutoDid() {
  let did = localStorage.getItem("ota_web_autodid");
  if (!did) {
    did = "web_" + Math.random().toString(36).substring(2, 11) + Date.now().toString(36);
    localStorage.setItem("ota_web_autodid", did);
  }
  return did;
}

export function mapGlassesModel(model) {
  if (!model) return "";
  const upper = model.toUpperCase();

  if (upper.includes("GEMINI")) {
    if (upper.includes("2") || upper.includes("2.0") || upper.includes("2P0")) {
      return "gemini2";
    }
    return "gemini1";
  }

  if (upper.includes("TAURUS")) {
    if (upper.includes("4.0") || upper.includes("4P0") || upper.includes("4")) {
      return "air4";
    }
    if (upper.includes("3.0") || upper.includes("3P0") || upper.includes("3")) {
      return "air3";
    }
    if (upper.includes("2.0") || upper.includes("2P0") || upper.includes("2")) {
      return "air2";
    }
    if (upper.includes("1.5") || upper.includes("1P5")) {
      return "air1p5";
    }
    return "taurus";
  }

  if (upper.includes("ARIES")) {
    if (upper.includes("1.8") || upper.includes("1P8")) {
      return "aries1p8";
    }
    if (upper.includes("1.5") || upper.includes("1P5")) {
      return "aries1p5";
    }
    return "aries";
  }

  return model.toLowerCase();
}

export function reportOTATracking(eventName, extraData = {}) {
  const { osType, osVersion, phoneModel } = getClientEnv();
  const autoDid = getAutoDid();

  const isOversea = location.hostname === "ota.rayneo.com" || location.hostname === "ota-hw-test.rayneo.cn";
  const devicetype1 = isOversea ? "web_com" : "web_cn";

  let result = "";
  if (eventName === "success") {
    result = "成功";
  } else if (eventName === "failed") {
    result = "失败";
  }

  const dataInfo = {
    type: "31C75A5ED8",
    event_name: eventName,
    os_type: osType,
    os_version: osVersion,
    phone_model: phoneModel,
    autoDid: autoDid,
    event_time: Date.now(),
    packageNm: extraData.packageNm || "",
    glassesVersion: extraData.glassesVersion || "",
    glassversion: extraData.glassesVersion || "",
    glasses_model: mapGlassesModel(extraData.glasses_model || ""),
    SN: extraData.SN || "",
    error_message: extraData.error_message || "",
    devicetype: "眼镜",
    devicetype1: devicetype1,
    result: result,
    destversion: extraData.destversion || "",
  };

  const dataObj = {
    basicInfo: toJSONKeyValue({
      userId: '584f9c5bab31fb1d59e138e1',
      projectId: '62902f81afae46c6a4a8dc1aa90ea4b5',
    }),
    dataInfo: toJSONKeyValue(dataInfo),
  };

  if (navigator.sendBeacon) {
    navigator.sendBeacon(reportUrl, new Blob([stringify(dataObj)], {
      type: 'application/x-www-form-urlencoded'
    }))
  } else {
    requestReport({
      url: reportUrl,
      method: 'POST',
      data: stringify(dataObj),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      }
    })
  }
}
